import { RigCostBase } from './base/rig-cost-base';

export class RigCost extends RigCostBase { }